import { HttpParams } from '@angular/common/http';

export class HttpUtils {

  /**
   * Build query params for list APIs.
   * Empty arrays / empty strings are omitted so "no filter" means all results
   * (sending status= or publishersIds= can make some backends return nothing).
   */
  static getHttpParams(obj): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(obj || {}).forEach(key => {
      const value = obj[key];
      if (value == null || value === '') {
        return;
      }
      if (Array.isArray(value)) {
        if (!value.length) {
          return;
        }
        httpParams = httpParams.set(key, value.join(','));
        return;
      }
      httpParams = httpParams.set(key, value);
    });
    return httpParams;
  }

  static getHttpParamsFromArray(name, array, httpParams = new HttpParams()) {
    return httpParams.set(name, array.join(','));
  }

  static getUrlParamsFrom(obj) {
    return Object.keys(obj).reduce((seed, current) => {
      if (seed) {
        seed += '&';
      }
      if (obj[current]) {
        seed += `${current}=${obj[current]}`;
      }
      return seed;
    }, '');
  }

  static appendHttpToUrlIfNotExists(url: string) {
    if (!url) {
      return;
    }
    const hasHttpInUrl = url.includes('http://');
    const hasHttpsInUrl = url.includes('https://');
    return (!hasHttpInUrl && !hasHttpsInUrl ) ? 'http://' + url : url;
  }
}
